import * as React from 'react'
import classnames from 'classnames'

import styles from '../styles.module.scss'
import { useField } from 'formik'

interface Props extends React.PropsWithChildren {
  htmlFor: string
}

export const Label: React.FC<Props> = (props) => {
  const [, meta] = useField(props.htmlFor)
  const labelClassName = classnames(styles.label, {
    [styles.errorText]: meta.error && meta.touched,
  })
  return (
    <label className={labelClassName} htmlFor={props.htmlFor}>
      {props.children}
    </label>
  )
}
